/** [Android only]
 * Listen for back button press on Android's 3-button navigation and respond with a callback.
 * @param callback
 * @param blockOtherListeners if true then all subscriptions registered earlier will not be invoked (e.g. if we want to override default behavior). Default is false.
 */
const useHardwareBackListener = (callback: () => void, blockOtherListeners: boolean = false) => {};
export default useHardwareBackListener;
